"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _officeNav = _interopRequireDefault(require("./officeNav"));

var _officeRightNav = _interopRequireDefault(require("./officeRightNav"));

var _officeRightSideBar = _interopRequireDefault(require("./officeRightSideBar"));

var _officeLeftSideBar = _interopRequireDefault(require("./officeLeftSideBar"));

var _officeSubNav = _interopRequireDefault(require("./officeSubNav"));

require("./officeHeader.scss");

var _angi_logo = _interopRequireDefault(require("../../browser/assets/angi_logo.svg"));

// eslint-disable-next-line import/no-named-default
var getUnifiedHeaderConfigs = function getUnifiedHeaderConfigs(_ref) {
  var currentSubNav = _ref.currentSubNav,
      selectedSubNavItem = _ref.selectedSubNavItem,
      hasBmt = _ref.hasBmt,
      hasOpportunityNotifications = _ref.hasOpportunityNotifications,
      instantBookingEnabled = _ref.instantBookingEnabled,
      isAdmin = _ref.isAdmin,
      isAngiLeads = _ref.isAngiLeads,
      showOpportunityLeadsNavLink = _ref.showOpportunityLeadsNavLink,
      isAdvertiser = _ref.isAdvertiser,
      isAuth = _ref.isAuth,
      isLoadingBusinessDetails = _ref.isLoadingBusinessDetails,
      leadsNotificationCount = _ref.leadsNotificationCount,
      logout = _ref.logout,
      numberOfBusinesses = _ref.numberOfBusinesses,
      proCity = _ref.proCity,
      proRegion = _ref.proRegion,
      proName = _ref.proName,
      proType = _ref.proType,
      rating = _ref.rating,
      reviewCount = _ref.reviewCount,
      reviewsNotificationCount = _ref.reviewsNotificationCount,
      showHeaderSubNav = _ref.showHeaderSubNav,
      spId = _ref.spId,
      displaySpId = _ref.displaySpId,
      toggleHeaderSubNav = _ref.toggleHeaderSubNav,
      userId = _ref.userId,
      getAdsServiceProvider = _ref.getAdsServiceProvider,
      isInboxEnabled = _ref.isInboxEnabled,
      messagesNotificationCount = _ref.messagesNotificationCount,
      onCloseSideBar = _ref.onCloseSideBar,
      isNorthStar = _ref.isNorthStar,
      isAgreementOnlineEnroll = _ref.isAgreementOnlineEnroll,
      isAngiLeadsAdmin = _ref.isAngiLeadsAdmin,
      showMonthlyBudget = _ref.showMonthlyBudget,
      showLeadFlow = _ref.showLeadFlow;
  var headerConfig;

  var handleCloseSideBar = function handleCloseSideBar() {
    onCloseSideBar();
  };

  var rightNav = [/*#__PURE__*/_react["default"].createElement(_officeRightNav["default"], {
    isAuth: isAuth,
    isLoadingBusinessDetails: isLoadingBusinessDetails,
    logout: logout,
    numberOfBusinesses: numberOfBusinesses,
    proCity: proCity,
    proRegion: proRegion,
    proName: proName,
    proType: proType,
    rating: rating,
    reviewCount: reviewCount,
    spId: spId,
    displaySpId: displaySpId,
    userId: userId,
    getAdsServiceProvider: getAdsServiceProvider,
    isAngiLeads: isAngiLeads,
    isAdvertiser: isAdvertiser,
    isNorthStar: isNorthStar,
    isAgreementOnlineEnroll: isAgreementOnlineEnroll
  })];
  var angiLeadsProperties = {
    hasOpportunityNotifications: hasOpportunityNotifications,
    instantBookingEnabled: instantBookingEnabled,
    isAngiLeads: isAngiLeads,
    showOpportunityLeadsNavLink: showOpportunityLeadsNavLink,
    showMonthlyBudget: showMonthlyBudget,
    showLeadFlow: showLeadFlow
  };

  if (isAuth) {
    var leftNavItems = spId ? [/*#__PURE__*/_react["default"].createElement(_officeNav["default"], {
      angiLeadsProperties: angiLeadsProperties,
      currentSubNav: currentSubNav,
      originalSubNav: currentSubNav,
      leadsNotificationCount: leadsNotificationCount,
      reviewsNotificationCount: reviewsNotificationCount,
      showHeaderSubNav: showHeaderSubNav,
      spId: spId,
      toggleHeaderSubNav: toggleHeaderSubNav,
      isInboxEnabled: isInboxEnabled,
      messagesNotificationCount: messagesNotificationCount,
      isAngiLeadsAdmin: isAngiLeadsAdmin
    })] : [];
    var leftSubNavItems = spId ? [/*#__PURE__*/_react["default"].createElement(_officeSubNav["default"], {
      angiLeadsProperties: angiLeadsProperties,
      currentSubNav: currentSubNav,
      isAdvertiser: isAdvertiser,
      isAdmin: isAdmin,
      hasBmt: hasBmt,
      selectedSubNavItem: selectedSubNavItem,
      showHeaderSubNav: showHeaderSubNav,
      spId: spId,
      toggleHeaderSubNav: toggleHeaderSubNav,
      isAngiLeadsAdmin: isAngiLeadsAdmin
    })] : undefined;
    var leftSideBarMenu = spId ? [/*#__PURE__*/_react["default"].createElement(_officeLeftSideBar["default"], {
      angiLeadsProperties: angiLeadsProperties,
      isAuth: true,
      hasBmt: hasBmt,
      isAdmin: isAdmin,
      isAdvertiser: isAdvertiser,
      leadsNotificationCount: leadsNotificationCount,
      reviewsNotificationCount: reviewsNotificationCount,
      spId: spId,
      proType: proType,
      closeSideBar: handleCloseSideBar,
      isAngiLeadsAdmin: isAngiLeadsAdmin
    })] : undefined;
    var rightSideBarMenu = spId ? [/*#__PURE__*/_react["default"].createElement(_officeRightSideBar["default"], {
      logout: logout,
      numberOfBusinesses: numberOfBusinesses,
      proCity: proCity,
      proRegion: proRegion,
      proName: proName,
      rating: rating,
      reviewCount: reviewCount,
      spId: spId,
      displaySpId: displaySpId,
      userId: userId,
      isAngiLeads: isAngiLeads,
      isAdvertiser: isAdvertiser,
      isNorthStar: isNorthStar,
      isAgreementOnlineEnroll: isAgreementOnlineEnroll
    })] : undefined;
    var hasNotifications = (leadsNotificationCount || 0) + (reviewsNotificationCount || 0) > 0 || hasOpportunityNotifications;
    headerConfig = {
      logo: _angi_logo["default"],
      homeLink: '/',
      hasNotifications: hasNotifications,
      leftNavItems: leftNavItems,
      leftSubNavItems: leftSubNavItems,
      rightNavItems: rightNav,
      responsiveSubNav: leftSubNavItems,
      rightSideBarMenu: rightSideBarMenu,
      sideBarMenu: leftSideBarMenu,
      responsiveRightNavItems: true,
      isInboxEnabled: isInboxEnabled,
      messagesNotificationCount: messagesNotificationCount
    };
  } else {
    headerConfig = {
      logo: _angi_logo["default"],
      homeLink: '/',
      rightNavItems: rightNav,
      responsiveNavItems: [/*#__PURE__*/_react["default"].createElement("div", {
        id: "unified-header-create-account-or-sign-in"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "unified-header-sign-in",
        id: "unified-header-right-nav--sign-in",
        href: _urlCatalog["default"].office.login()
      }, "Sign in"), /*#__PURE__*/_react["default"].createElement("a", {
        className: "unified-header-nav-item",
        id: "unified-header-right-nav--create-an-account",
        href: _urlCatalog["default"].office.join()
      }, "Join us"))],
      sideBarMenu: [/*#__PURE__*/_react["default"].createElement(_officeLeftSideBar["default"], {
        isAuth: false,
        hasBmt: hasBmt,
        isAdmin: isAdmin,
        isAdvertiser: isAdvertiser,
        leadsNotificationCount: leadsNotificationCount,
        reviewsNotificationCount: reviewsNotificationCount,
        spId: spId,
        isInboxEnabled: isInboxEnabled,
        messagesNotificationCount: messagesNotificationCount,
        proType: proType,
        closeSideBar: handleCloseSideBar
      })]
    };
  }

  return headerConfig;
};

var _default = getUnifiedHeaderConfigs;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/unifiedHeaderConfig.js
// module id = 3655
// module chunks = 25